import React from 'react';

const Icon = ({ width = '47', height = '46', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 47 46" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="2.136" strokeLinecap="round" strokeLinejoin="round">
                <path d="m39.155 9.449 2.278 5.069 1.054 1.438-1.281 17.158-1.367 2.05-12.502 1.737H23.25L5.138 34.523l-.227-2.306.484-14.823.954-3.232 20.219-4.998 12.573.3" />

                <path d="m20.16 10.914 7.148 6.55-.555 16.26L23.25 36.9m3.26-27.765-.327 3.389 1.98 1.751 13.1-.128-2.122-4.713-12.63-.3Z" />

                <path d="M42.174 20.212 40.11 17.48l-9.013.156-3.887 2.592m5.694-2.636L32.15 36.23m5.324-18.709-.84 18.084" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M.924.236h45.565v45.565H.924z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
